<script lang="ts">
    let className = 'h-1 w-[104px] rounded-lg hover:cursor-pointer active:cursor-grab';
    export { className as class };

    export let value;
</script>

<input
    type="range"
    min={0}
    max="1"
    bind:value
    step="0.1"
    class="range p-0 {className} "
    on:input
    style="background: linear-gradient(to right, #fff {value * 100}%, #333 {value * 100}%"
/>

<style>
    input[type='range'] {
        -webkit-appearance: none;
        appearance: none;
        width: 104px;
        cursor: pointer;
        outline: none;
        border-radius: 15px;
        height: 4px;
        background: #333333;
    }

    /* Thumb: webkit */
    input[type='range']::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        height: 15px;
        width: 15px;
        background-color: #fff;
        border-radius: 50%;
        border: none;
        transition: 0.2s ease-in-out;
    }
</style>
